export default __webpack_public_path__ + "static/blogBG1-mobile-fb3fad6e08dacacc7cfb02a8f76ba80d.svg";